export default __webpack_public_path__ + "static/ogg-image-default-6b7aa8933469a72fd3c46da768590516.png";